import { render, staticRenderFns } from "./OrgMainInfo.vue?vue&type=template&id=edf72202&scoped=true&"
import script from "./OrgMainInfo.vue?vue&type=script&lang=js&"
export * from "./OrgMainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf72202",
  null
  
)

export default component.exports